export const statusColors = {
  ACCESSED: 'bg-success-50 text-success-500',
  PENDING: 'bg-progress-50 text-progress-500',
  REJECTED: 'bg-error-50 text-error-500'
};

export const actionStatus = ['ACCESSED', 'PENDING', 'REJECTED'];
